import FormTemplate from './form';
var EditableTemplate = /** @class */ (function () {
    function EditableTemplate() {
        this.form = FormTemplate;
        this.setElement();
        this.setError(false);
    }
    EditableTemplate.prototype.setTemplate = function (template) {
        var inputs = this.el.querySelector('.aceditable__form__inputs');
        inputs.innerHTML = '';
        inputs.insertAdjacentHTML('afterBegin', template);
    };
    EditableTemplate.prototype.setError = function (error) {
        var error_element = this.el.querySelector('.aceditable__form__error');
        if (error) {
            error_element.innerHTML = error;
            error_element.style.display = 'block';
        }
        else {
            error_element.style.display = 'none';
        }
    };
    EditableTemplate.prototype.addClass = function (className) {
        this.el.classList.add(className);
    };
    EditableTemplate.prototype.setSubmitButton = function (label) {
        this.el.querySelector('[data-submit]').innerHTML = label;
    };
    EditableTemplate.prototype.showButtons = function (show) {
        if (show === void 0) { show = true; }
        var controls = this.el.querySelector('.aceditable__form__controls');
        if (show) {
            controls.style.display = 'block';
        }
        else {
            controls.style.display = 'none';
        }
    };
    EditableTemplate.prototype.setElement = function () {
        var element = document.createElement('div');
        element.classList.add('aceditable');
        element.innerHTML = EditableTemplate.getElementMarkup();
        this.el = element;
    };
    EditableTemplate.getElementMarkup = function () {
        return "\t\t\n\t\t\t<div class=\"aceditable__content\">\n\t\t\t\t<form class=\"aceditable__form\" autocomplete=\"nope\">\n\t\t\t\t\t<div class=\"aceditable__form__inputs\">\n\t\t\t\t\t\t\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"aceditable__form__controls\">\n\t\t\t\t\t\t<button data-submit=\"\" class=\"button aceditable__button -primary\"><span class=\"dashicons dashicons-yes\"></span></button>\n\t\t\t\t\t\t<button data-cancel=\"\" class=\"button aceditable__button\"><span class=\"dashicons dashicons-no\"></span></button>\n\t\t\t\t\t</div>\n\t\t\t\t</form>\n\t\t\t\t<div class=\"aceditable__form__error\"></div>\n\t\t\t</div>\n\t\t\t<div class=\"aceditable__spinner spinner\"></div>\n\t\t";
    };
    return EditableTemplate;
}());
export default EditableTemplate;
